import { Button } from "@/components/ui/button";
import { Tooltip } from "@/components/ui/tooltip";
import { PhoneCallIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { CallDialog } from "./call-dialog";
import { useTranslation } from "@/features/utils/i18n";

/**
 * `compact` is the conversation list's variant: at the head of a 22rem pane
 * there is room for the glyph and its tooltip, not for the label.
 */
export function CallButton({ compact }: { compact?: boolean }) {
  const { t } = useTranslation("calls");
  const [dialogOpen, setDialogOpen] = useState(false);

  const button = compact ? (
    <Tooltip content={t("newCall")}>
      <Button
        size="icon"
        className="shrink-0"
        onClick={() => setDialogOpen(true)}
        aria-label={t("newCall")}
      >
        <PhoneCallIcon className="h-4 w-4" weight="fill" />
      </Button>
    </Tooltip>
  ) : (
    <Button onClick={() => setDialogOpen(true)}>
      <PhoneCallIcon className="h-4 w-4" weight="fill" />
      {t("newCall")}
    </Button>
  );

  return (
    <>
      {button}
      <CallDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  );
}
